// @flow
import { translate } from '../../../react/features/base/i18n/functions';
import Button from '../../../react/features/base/ui/components/web/Button';
import { BUTTON_TYPES } from '../../../react/features/base/ui/constants.any';
import React, { PureComponent } from 'react';
import WildixUIEvents from '../../service/WildixUIEvents';

import PopupOverlay from './PopupOverlay';


type Props = {

    title: String,

    /**
     * Invoked to obtain translated strings.
     */
    t: Function,

    text: String
}


class PopupRejoin extends PureComponent<Props> {
    static defaultProps = {
        title: 'notification.YouHaveLeftConference',
        text: 'notification.YouHaveLeftConferenceText'
    };

    componentDidMount() {
        APP.wildix.eventEmitter.emit(WildixUIEvents.DIALOG_OPENED, 'rejoin');
    }


    _onReload = () => {
        window.location.reload();
    };

    render() {
        const { title, text, t } = this.props;

        return (
            <PopupOverlay className={'popup__rejoin'}>
                <div className='popup__header'>
                    <h2 className={'color-white font_bold'}>
                        { t(title) }
                    </h2>
                </div>
                <div className='popup__body'>
                    <h3 className={'color-white'}>
                        { t(text) }
                    </h3>
                </div>
                <div className="popup_footer flex_hor_end">
                    <Button
                        type = { BUTTON_TYPES.PRIMARY }
                        onClick={this._onReload}
                        id={'modal-dialog-ok-button'}
                        labelKey={t('button.JoinAgain') }
                    />
                </div>
            </PopupOverlay>
        );
    }
}

export default translate(PopupRejoin);
